import { DeviceCaptureActivityCreatedMessage, DeviceLogsDownloadReadyMessage, DeviceLogsRequestCompletedMessage, ServerStatusMessage, VideoDownloadLinkMessage, VideoRecordingCancelMessage, VideoRecordingDownloadReadyMessage, VideoRecordingNameMessage, VideoRecordingStartMessage, VideoRecordingStopMessage } from "../messages/xsight";
import { RequestReplyService } from "../../remote-control-ng/services/requestReplyService";
import { BaseCommand } from "./baseCommand";
import { RcContext } from "../../remote-control-ng/context/rcContext";
import { Injector } from "@angular/core";

export class VideoRecordingCancelCommand extends BaseCommand<VideoRecordingCancelMessage> {
    constructor(private injector: Injector) {
        super(VideoRecordingCancelMessage);
    }

    protected doProcess(message: VideoRecordingCancelMessage): void {
        if (message.isRequest) {
            this.injector.get(RequestReplyService).processReply(message);
        }
    }
}

export class VideoRecordingStartCommand extends BaseCommand<VideoRecordingStartMessage> {
    constructor() { super(VideoRecordingStartMessage); }

    protected doProcess(message: VideoRecordingStartMessage): void {
        const evt = Object.assign(new Event('rcVideoRecordingStarted', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId
        });
        document.dispatchEvent(evt);
    }
}

export class VideoRecordingStopCommand extends BaseCommand<VideoRecordingStopMessage> {
    constructor() { super(VideoRecordingStopMessage); }

    protected doProcess(message: VideoRecordingStopMessage): void {
        const evt = Object.assign(new Event('rcVideoRecordingStopped', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId
        });
        document.dispatchEvent(evt);

    }
}

export class VideoFileNameCommand extends BaseCommand<VideoRecordingNameMessage> {
    constructor() { super(VideoRecordingNameMessage); }

    protected doProcess(message: VideoRecordingNameMessage): void {
        if (RcContext.instance.featureToggleService.isEnabled("DeveloperMode")) {
            console.log("RC:VideoNameReturned");
        }
        RcContext.instance.recordedVideoName = message.fileName;
        const evt = Object.assign(new Event('rcSetVideoRecordingFileName', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId
        });
        document.dispatchEvent(evt);

    }
}

export class VideoRecordingDownloadReadyCommand extends BaseCommand<VideoRecordingDownloadReadyMessage> {
    constructor() { super(VideoRecordingDownloadReadyMessage); }

    protected doProcess(message: VideoRecordingDownloadReadyMessage): void {
        RcContext.instance.videoActivityId = message.draftActivity.activityId;
        const evt = Object.assign(new Event('rcVideoDownloadReady', {'bubbles':true, 'cancelable':true}), {
            fileInfo: { attachmentId: message.draftActivity.fileId, fileName: message.draftActivity.fileName }
        });
        document.dispatchEvent(evt);

    }
}

export class DeviceLogsDownloadReadyCommand extends BaseCommand<DeviceLogsDownloadReadyMessage> {
    constructor() { super(DeviceLogsDownloadReadyMessage); }

    protected doProcess(message: DeviceLogsDownloadReadyMessage): void {
        if (RcContext.instance.featureToggleService.isEnabled("DeveloperMode")) {
            console.log("RC:DeviceLogsDownloadReady");
        }
        const deviceLogsDownloadReadyDetails = message.response;
        const evt = Object.assign(new Event('rcDeviceLogsDownloadReady', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId,
            deviceLogsDownloadReadyDetails: deviceLogsDownloadReadyDetails
        });
        document.dispatchEvent(evt);

    }
}

export class DeviceCaptureActivityCreatedCommand extends BaseCommand<DeviceCaptureActivityCreatedMessage> {
    constructor() { super(DeviceCaptureActivityCreatedMessage); }

    protected doProcess(message: DeviceCaptureActivityCreatedMessage): void {
        if (RcContext.instance.featureToggleService.isEnabled("DeveloperMode")) {
            console.log("RC:Device Capture activity returned");
        }
        RcContext.instance.draftDeviceCaptureActivity = message.response;
        const evt = Object.assign(new Event('rcDeviceCaptureActivityCreated', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId
        });
        document.dispatchEvent(evt);

    }
}

export class DeviceLogsRequestCompletedCommand extends BaseCommand<DeviceLogsRequestCompletedMessage> {
    constructor() { super(DeviceLogsRequestCompletedMessage); }

    protected doProcess(message: DeviceLogsRequestCompletedMessage): void {
        if (RcContext.instance.featureToggleService.isEnabled("DeveloperMode")) {
            console.log("RC:Device logs uploaded");
        }
        RcContext.instance.draftDeviceCaptureActivity = message.response;
        const evt = Object.assign(new Event('rcDeviceLogsRequestCompleted', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId,
        });
        document.dispatchEvent(evt);

    }
}

export class ServerStatusCommand extends BaseCommand<ServerStatusMessage> {
    constructor() { super(ServerStatusMessage); }

    protected doProcess(message: ServerStatusMessage): void {
        if (RcContext.instance.featureToggleService.isEnabled("DeveloperMode")) {
            console.log("RC:ServerStatusUpdate");
        }

        RcContext.instance.serverStatus = message.response;
        const evt = Object.assign(new Event('rcServerStatusUpdate', {'bubbles':true, 'cancelable':true}), {
            deviceId: RcContext.instance.deviceId
        });
        document.dispatchEvent(evt);

    }
}

export class VideoDownloadLinkCommand extends BaseCommand<VideoDownloadLinkMessage> {
    constructor(private injector: Injector) {
        super(VideoDownloadLinkMessage);
        
    }

    protected doProcess(message: VideoDownloadLinkMessage): void {
        if (message.isRequest) {
            this.injector.get(RequestReplyService).processReply(message);
        }
    }
}
